<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>

  <ng-container *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline">
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <li nz-submenu nzTitle="{{'cau_hinh_chung' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <ul class="submenu" nz-menu nzMode="inline">
          <!-- Kiểu viền -->
          <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['tab-bar']" [id_object]="objectChoosing._id">
            </app-borders-config>

            <!-- Nút mở rộng -->
            <div class="item-border my-3" style="float: right">
              <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
                {{'mo_rong' | translate}} &#8594;
              </p>
            </div>
          </li>

          <!-- Cấu hình đổ bóng -->
          <li nz-submenu nzTitle="{{'do_bong' | translate}}">
            <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['tab-bar']" [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
            </app-shadow-config>
          </li>

          <!-- Cấu hình màu nền của tab-bar -->
          <li nz-submenu nzTitle="{{'mau_nen' | translate}}">
            <div class="container-color">
              <button id="btn-color" *ngFor="let background of backgroundColor; let i = index" [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event, 'tab-bar')" nz-tooltip [disabled]="config['background-color'].gradient_check"></button>
            </div>
            <div class="color-pick mb-4">
              <span class="title w-50">{{'mau_nen' | translate}}</span>
              <input
                class="input-color w-50" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['tab-bar']['background-color']"
                [style.background]="class['tab-bar']['background-color']"
                (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [disabled]="config['background-color'].gradient_check"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)"
              />
            </div>
            <div class="mr-2 mb-4 mt-4 view-more" style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 7px;
              ">
              <p class="discover_text" (click)="openViewAll(styles_field[3])"
                style="cursor: pointer; text-align: left; margin: 0">
                {{'mau_gradient' | translate}} &#8594;
              </p>
            </div>
          </li>

          <!-- Thay đổi vị trí  -->
          <li nz-submenu nzTitle="{{'thay_doi_vi_tri' | translate}}">
            <div class="mt-2 mb-2">
              <nz-radio-group [(ngModel)]="class['tab-bar']['flex-direction']"
                (ngModelChange)="updateClass()">
                <label nz-radio nzValue="column">{{ 'doc' | translate}}</label>
                <label nz-radio nzValue="row">{{ 'ngang' | translate}}</label>
              </nz-radio-group>
            </div>
         </li>

          <!-- Hiển thị ở trạng thái nào -->
          <li nz-submenu nzTitle="{{'hien_thi_tab' | translate}}">
            <div class="mt-2 mb-2">
              <nz-radio-group [(ngModel)]="config['mode_show']"
                (ngModelChange)="updateConfig()">
                <label nz-radio nzValue="text">{{ 'hien_thi_text' | translate}}</label>
                <label nz-radio nzValue="icon">{{ 'hien_thi_icon' | translate}}</label>
                <label nz-radio nzValue="both">{{ 'hien_thi_text_va_icon' | translate}}</label>
              </nz-radio-group>
            </div>
         </li>
        </ul>
      </li>
      <li nz-submenu nzTitle="{{'them_du_lieu_tab' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <button (click)="visibleAdd = true" nz-button nzType="primary">{{'them_tab' | translate}}</button>
      </li>
      <li nz-submenu nzTitle="{{'cau_hinh_khi_chon' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <ul class="submenu" nz-menu nzMode="inline">
          <li nz-submenu nzTitle="{{'dinh_dang' | translate}}">
            <div class="container-font">
              <div class="config-text" style="width: 100%">
                <app-text-format-config
                  [objectChoosing]="objectChoosing"
                  [device]="device"
                  [class]="class"
                  [config]="config"
                  [staticdata]="staticdata"
                  [textContentClass]="class['tab-bar__label-active']"
                  [textWrapperClass]="class['tab-bar__item']"
                  (changeTextAlignConfig)="changeWidthHeight({width: width})"
                >
                </app-text-format-config>
                <!-- Khoảng cách chữ -->
                <app-letter-spacing-config
                  [objectChoosing]="objectChoosing"
                  [device]="device"
                  [class]="class"
                  [classLetterSpacing]="class['tab-bar__label-active']"
                  (updateClass)="updateClass()"
                >
                </app-letter-spacing-config>
                <!-- Khoảng cách dòng -->
                <app-line-height-config
                  [objectChoosing]="objectChoosing"
                  [device]="device"
                  [class]="class"
                  [classLineHeight]="class['tab-bar__label-active']"
                  (updateClass)="updateClass()"
                >
                </app-line-height-config>
                <!-- Màu icon -->
                <div class="space-middle">
                  <div class="slide-bar">
                    <p class="m-0 title w-50">{{'mau_sac_icon' | translate}}</p>
                    <input style="width: 50%; height:30px" class="input-color" type="button"
                      [cpOKButton]="true"
                      [(colorPicker)]="class['tab-bar__icon-active'].color"
                      [style.background]="class['tab-bar__icon-active'].color"
                      (colorPickerClose)="updateClass()"
                      [cpWidth]="'230px'"
                      [cpMaxPresetColorsLength]="functionService.cpMaxPresetColorsLength"
                      [cpAddColorButton]="true"
                      [cpAddColorButtonText]="'them_mau' | translate"
                      [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="functionService.themeColors"
                      (cpPresetColorsChange)="functionService.presetColorsChange($event)"
                    />
                  </div>
                  <div class="slide-bar mt-2">
                    <p class="m-0 title">{{'kich_thuoc_icon' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                            class['tab-bar__icon-active']['font-size'] | vhnumber
                            " (nzBlur)="updateClass()" (ngModelChange)="
                            class['tab-bar__icon-active']['font-size'] =
                                $event + 'px'"></nz-input-number>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- Hình ảnh -->
         <li nz-submenu nzTitle="{{'hinh_anh' | translate}}">
           <div>
             <div style="flex-direction: column; gap: 12px;" class="config-name">
               <div class="slide-bar">
                 <p class="m-0 title">{{'chieu_rong' | translate}}</p>
                 <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                     class['tab-bar__img-active']['width'] | vhnumber
                     " (nzBlur)="updateClass()" (ngModelChange)="
                     class['tab-bar__img-active']['width'] =
                     $event + 'px'"></nz-input-number>
               </div>
               <div class="slide-bar">
                 <p class="m-0 title">{{'chieu_cao' | translate}}</p>
                 <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                     class['tab-bar__img-active']['height'] | vhnumber
                     " (nzBlur)="updateClass()" (ngModelChange)="
                     class['tab-bar__img-active']['height'] =
                     $event + 'px'"></nz-input-number>
               </div>
             </div>
           </div>
          </li>
          <!-- Cấu hình màu nền của tab-bar item-->
          <li nz-submenu nzTitle="{{'mau_nen' | translate}}">
            <div class="container-color">
              <button id="btn-color" *ngFor="let background of backgroundColor; let i = index" [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event, 'tab-bar__item-active')" nz-tooltip [disabled]="config['background-color'].gradient_check"></button>
            </div>
            <div class="color-pick mb-4">
              <span class="title w-50">{{'mau_nen' | translate}}</span>
              <input
                class="input-color w-50" type="button"
                [cpOKButton]="true"
                [(colorPicker)]="class['tab-bar__item-active']['background-color']"
                [style.background]="class['tab-bar__item-active']['background-color']"
                (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [disabled]="config['background-color'].gradient_check"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)"
              />
            </div>
          </li>
          <!-- Thay đổi vị trí  -->
          <li nz-submenu nzTitle="{{'thay_doi_vi_tri' | translate}}">
            <div class="mt-2 mb-2">
              <nz-radio-group [(ngModel)]="class['tab-bar__item-active']['flex-direction']"
                (ngModelChange)="updateClass()">
                <label nz-radio nzValue="column">{{ 'doc' | translate}}</label>
                <label nz-radio nzValue="row">{{ 'ngang' | translate}}</label>
              </nz-radio-group>
            </div>
         </li>
          <!-- Khoảng cách giữa text và icon -->
          <li nz-submenu nzTitle="{{'khoang_cach_nhan_va_icon' | translate}}">
            <div>
              <div class="config-name">
                <nz-input-number style="width: 100%;" [nzMin]="0" [nzMax]="250"
                  [ngModel]="class['tab-bar__item-active']['gap'] | vhnumber" (ngModelChange)="
                    class['tab-bar__item-active']['gap'] = $event + 'px';"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="250"
                [ngModel]="class['tab-bar__item-active']['gap'] | vhnumber" (ngModelChange)="
                    class['tab-bar__item-active']['gap'] = $event + 'px';"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
          </li>
        </ul>
      </li>
      <li nz-submenu nzTitle="{{'cau_hinh_khi_khong_chon' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <ul class="submenu" nz-menu nzMode="inline">
          <li nz-submenu nzTitle="{{'dinh_dang' | translate}}">
            <div class="container-font">
              <div class="config-text" style="width: 100%">
                <app-text-format-config
                  [objectChoosing]="objectChoosing"
                  [device]="device"
                  [class]="class"
                  [config]="config"
                  [staticdata]="staticdata"
                  [textContentClass]="class['tab-bar__label']"
                  [textWrapperClass]="class['tab-bar__item']"
                  (changeTextAlignConfig)="changeWidthHeight({width: width})"
                >
                </app-text-format-config>
                <!-- Khoảng cách chữ -->
                <app-letter-spacing-config
                  [objectChoosing]="objectChoosing"
                  [device]="device"
                  [class]="class"
                  [classLetterSpacing]="class['tab-bar__label']"
                  (updateClass)="updateClass()"
                >
                </app-letter-spacing-config>
                <!-- Khoảng cách dòng -->
                <app-line-height-config
                  [objectChoosing]="objectChoosing"
                  [device]="device"
                  [class]="class"
                  [classLineHeight]="class['tab-bar__label']"
                  (updateClass)="updateClass()"
                >
                </app-line-height-config>
                <!-- Màu icon -->
                <div class="space-middle">
                  <div class="slide-bar">
                    <p class="m-0 title w-50">{{'mau_sac_icon' | translate}}</p>
                    <input style="width: 50%; height:30px" class="input-color" type="button"
                      [cpOKButton]="true"
                      [(colorPicker)]="class['tab-bar__icon'].color"
                      [style.background]="class['tab-bar__icon'].color"
                      (colorPickerClose)="updateClass()"
                      [cpWidth]="'230px'"
                      [cpMaxPresetColorsLength]="functionService.cpMaxPresetColorsLength"
                      [cpAddColorButton]="true"
                      [cpAddColorButtonText]="'them_mau' | translate"
                      [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="functionService.themeColors"
                      (cpPresetColorsChange)="functionService.presetColorsChange($event)"
                    />
                  </div>

                  <!-- kích thước icon -->
                  <div class="slide-bar mt-2">
                    <p class="m-0 title">{{'kich_thuoc_icon' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                            class['tab-bar__icon']['font-size'] | vhnumber
                            " (nzBlur)="updateClass()" (ngModelChange)="
                            class['tab-bar__icon']['font-size'] =
                                $event + 'px'"></nz-input-number>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- Hình ảnh -->
          <li nz-submenu nzTitle="{{'hinh_anh' | translate}}">
           <div>
             <div style="flex-direction: column; gap: 12px;" class="config-name">
               <div class="slide-bar">
                 <p class="m-0 title">{{'chieu_rong' | translate}}</p>
                 <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                     class['tab-bar__img']['width'] | vhnumber
                     " (nzBlur)="updateClass()" (ngModelChange)="
                     class['tab-bar__img']['width'] =
                     $event + 'px'"></nz-input-number>
               </div>
               <div class="slide-bar">
                 <p class="m-0 title">{{'chieu_cao' | translate}}</p>
                 <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                     class['tab-bar__img']['height'] | vhnumber
                     " (nzBlur)="updateClass()" (ngModelChange)="
                     class['tab-bar__img']['height'] =
                     $event + 'px'"></nz-input-number>
               </div>
             </div>
           </div>
          </li>
          <!-- Cấu hình màu nền của tab-bar item-->
          <li nz-submenu nzTitle="{{'mau_nen' | translate}}">
            <div class="container-color">
              <button id="btn-color" *ngFor="let background of backgroundColor; let i = index" [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event, 'tab-bar__item-active')" nz-tooltip [disabled]="config['background-color'].gradient_check"></button>
            </div>
            <div class="color-pick">
              <span class="title w-50">{{'mau_nen' | translate}}</span>
              <input
                class="input-color w-50" type="button"
                [cpOKButton]="true"
                [(colorPicker)]="class['tab-bar__item']['background-color']"
                [style.background]="class['tab-bar__item']['background-color']"
                (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)"
              />
            </div>
          </li>
          <!-- Thay đổi vị trí  -->
          <li nz-submenu nzTitle="{{'thay_doi_vi_tri' | translate}}">
            <div class="mt-2 mb-2">
              <nz-radio-group [(ngModel)]="class['tab-bar__item']['flex-direction']"
                (ngModelChange)="updateClass()">
                <label nz-radio nzValue="column">{{ 'doc' | translate}}</label>
                <label nz-radio nzValue="row">{{ 'ngang' | translate}}</label>
              </nz-radio-group>
            </div>
          </li>
          <!-- Khoảng cách giữa text và icon -->
          <li nz-submenu nzTitle="{{'khoang_cach_nhan_va_icon' | translate}}">
            <div>
              <div class="config-name">
                <nz-input-number style="width: 100%;" [nzMin]="0" [nzMax]="250"
                  [ngModel]="class['tab-bar__item']['gap'] | vhnumber" (ngModelChange)="
                    class['tab-bar__item']['gap'] = $event + 'px';"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="250"
                [ngModel]="class['tab-bar__item']['gap'] | vhnumber" (ngModelChange)="
                    class['tab-bar__item']['gap'] = $event + 'px';"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['tab-bar']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize" [device]="device"></app-animations-config>
    </div>

    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check" (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="
            let bgGradient of config['background-color']['gradient_arr'];
            let i = index
          " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }" [disabled]="!config['background-color'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{'them_mau' | translate}}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['background-color'].background" type="button" [disabled]="!config['background-color'].gradient_check" [style.background]="config['background-color'].background" (colorPickerClose)="addGradient($event)" />
      </div>
      <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
      <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)" [disabled]="!config['background-color'].gradient_check" [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'" [class.active]="config['background-color'].gradient_direction === type.direction">
      </button>
    </div>
  </div>
</div>

<nz-modal nzTitle="{{'them_tab' | translate}}" [(nzVisible)]="visibleAdd" nzWidth="50vw" [nzOkLoading]="isConfirmLoading" (nzOnCancel)="visibleAdd = false" (nzOnOk)="saveTab()">

  <ng-container *nzModalContent>

    <nz-radio-group style="width: 100%" [(ngModel)]="activeIndex" (ngModelChange)="onActiveChange($event)">
      <nz-table #basicTable [nzData]="staticdata.nav_item || []" [nzBordered]="true" [nzScroll]="{ y: '340px' }" [nzSize]="'middle'" [nzShowPagination]="false">
        <thead>
          <tr>
            <th style="text-align: center;">{{'nhan' | translate}}</th>
            <th style="text-align: center;">{{'loai' | translate}}</th>
            <th style="text-align: center;">{{'xem_truoc' | translate}}</th>
            <th style="text-align: center;">{{'duong_dan_trang' | translate}}</th>
            <th style="text-align: center;">{{'kich_hoat' | translate}}</th>
            <th style="text-align: center;">{{'xoa' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of basicTable.data; let i = index">
            <!-- Label -->
            <td style="text-align: center;">
              <input nz-input [(ngModel)]="item.label" [placeholder]="'enter label' | translate" />
            </td>
            <!-- Type -->
            <td style="text-align: center;">
              <nz-select [(ngModel)]="item.type" [nzPlaceHolder]="'select type' | translate">
                <nz-option nzValue="icon" [nzLabel]="'Icon' | translate"></nz-option>
                <nz-option nzValue="image" [nzLabel]="'image' | translate"></nz-option>
              </nz-select>
            </td>
            <!-- Preview -->
            <td style="text-align: center;">
              <div style="display: flex; align-items: center; justify-content: center; gap: 8px">
                <ng-container *ngIf="item.type === 'icon'">
                  <mat-icon>{{ item.icon }}</mat-icon>
                  <button nz-button nzType="primary" size="small" (click)="openDialogChooseIcon(item)">
                    {{'chon_icon' | translate}}
                  </button>
                </ng-container>
                <ng-container *ngIf="item.type === 'image'">
                  <img [src]="item.image" style="width: 40px; height: 40px;" />
                  <button nz-button nzType="primary" size="small" (click)="openDialogChooseImage(item)">
                    {{'chon_anh' | translate}}
                  </button>
                </ng-container>
              </div>
            </td>
            <td style="text-align: center;">
              <nz-select [(ngModel)]="item.link" [nzPlaceHolder]="'chon_trang' | translate">
                <nz-option *ngFor="let page of listPage" [nzValue]="page.link" [nzLabel]="page['name_' + functionService.selectedLanguageCode]"></nz-option>
              </nz-select>
            </td>
            <!-- Active -->
            <td style="text-align: center;">
              <label nz-radio [nzValue]="i"></label>
            </td>
            <!-- Delete -->
            <td style="text-align: center;">
              <button nz-button nzType="default" nzDanger size="small" (click)="removeTab(i)">
                {{'xoa' | translate}}
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-radio-group>

    <!-- Add button -->
    <div class="container_add-tab" style="margin-top: 16px;">
      <button (click)="addTab()" nz-button nzType="primary">
        {{'them_tab' | translate}}
      </button>
    </div>

  </ng-container>
</nz-modal>

<nz-modal
  nzTitle="{{'chon_anh' | translate}}"
  [(nzVisible)]="navItemImageModalVisible"
  [nzOkLoading]="navItemImageSaving"
  [nzOkDisabled]="!canSaveNavItemImage()"
  (nzOnCancel)="closeNavItemImageModal()"
  (nzOnOk)="saveNavItemImage()"
>
  <ng-container *nzModalContent>
    <div class="nav-item-image-modal">
      <div class="nav-item-image-source">
        <span>{{'nguon_hinh_anh_hien_thi_len' | translate}}</span>
        <nz-select [(ngModel)]="navItemImageSource" (ngModelChange)="onNavItemImageSourceChange($event)" style="width: 100%">
          <nz-option nzValue="device" [nzLabel]="'tu_thiet_bi' | translate"></nz-option>
          <nz-option nzValue="url" [nzLabel]="'duong_dan_hinh_anh' | translate"></nz-option>
        </nz-select>
      </div>

      <ng-container *ngIf="navItemImageSource === 'device'; else navItemImageUrlTpl">
        <input
          id="navItemUpload"
          type="file"
          accept="image/*"
          style="display: none"
          (change)="onNavItemImageSelected($event)"
        />

        <div
          class="drop-zone nav-item-drop-zone"
          [class.dragging]="dragging"
          (drop)="onNavItemFileDropped($event)"
          (dragover)="onDragOver_upload($event)"
          (dragleave)="onDragLeave_upload()"
        >
          <label *ngIf="!navItemImagePreviewUrl" for="navItemUpload">
            <mat-icon>image</mat-icon>
            <p>{{ 'keo_hinh_anh_vao_day_hoac' | translate }} <span>{{ 'tai_tep_len' | translate }}</span></p>
          </label>

          <div *ngIf="navItemImagePreviewUrl" class="preview">
            <img [src]="navItemImagePreviewUrl" alt="Preview" />
          </div>

          <div *ngIf="navItemImagePreviewUrl" class="gr-btn button-list">
            <button type="button" (click)="openNavItemUpload()">
              <mat-icon>vertical_align_top</mat-icon>
            </button>
            <button type="button" (click)="navItemImagePreviewUrl = null; navItemImageFile = null">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>

      <ng-template #navItemImageUrlTpl>
        <div class="nav-item-image-url">
          <textarea
            nz-input
            rows="4"
            [placeholder]="'nhap_duong_dan_anh' | translate"
            [(ngModel)]="navItemImagePreviewUrl"
          ></textarea>

          <div *ngIf="navItemImagePreviewUrl" class="nav-item-url-preview">
            <img [src]="navItemImagePreviewUrl" alt="Preview" />
          </div>
        </div>
      </ng-template>
    </div>
  </ng-container>
</nz-modal>
